<template>
  <div class="review-summary p-24 flex-col">
    <div class="flex">
      <a-input-search
        style="width: 300px"
        placeholder="请输入投标单位名称"
        enter-button
        class="m-r-24"
        @search="handleSearch"
      />
      <el-button v-if="showReStart" type="primary" @click="reStartReview">
        重新评审
      </el-button>
    </div>
    <el-scrollbar class="scrollbar-y-hidden m-t-24 flex-1">
      <!-- width 99%是为了显示被el-scrollbar隐藏的右边border -->
      <el-table :data="tableData" border style="width: 99%">
        <el-table-column
          label="序号"
          type="index"
          width="60px"
          align="center"
          fixed="left"
        />
        <el-table-column
          label="报价单位"
          align="center"
          fixed="left"
          prop="supplierName"
          width="160px"
        />
        <el-table-column
          v-for="head in tableHead"
          :key="head.label"
          :label="head.label"
          align="center"
          min-width="160px"
        >
          <template v-slot:default="{ row }">
            <span :class="getTdContent(head, row).className">
              {{ getTdContent(head, row).content }}
            </span>
          </template>
        </el-table-column>
        <template v-if="inTask">
          <el-table-column
            v-for="item in reviewWay.itemInfoList"
            :key="item.wayItemId"
            :label="item.itemName"
            align="center"
            min-width="160px"
          >
            <template v-slot:default="{ row }">
              <div class="review-point">
                <div class="point-item">
                  <span v-if="isPassWay" class="item-label">结论</span>
                  <span v-else class="item-label">打分</span>
                  <span
                    :class="{
                      'text-danger': getRowScore(row, item) === '不通过'
                    }"
                  >
                    {{ getRowScore(row, item) }}
                  </span>
                </div>
                <div class="point-item">
                  <span class="item-label">备注</span>
                  <!--<span>{{ getRowRemark(row, item) }}</span>-->
                  <row-ellipsis :content="getRowRemark(row, item)" />
                </div>
                <div class="point-item">
                  <span class="item-label">评分标准</span>
                  <row-ellipsis
                    :content="item.itemStandard"
                    :content-style="{ color: '#999' }"
                    class="p-r-24"
                  />
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        @pagination="getTableData"
      />
    </el-scrollbar>

    <div v-if="showFoot" class="summary-foot">
      <el-button
        :disabled="submitDisabled"
        type="primary"
        @click="submitReviewSummary"
      >
        确认汇总
      </el-button>
    </div>

    <online-review-way-item-dialog
      ref="onlineReviewWayItemDialog"
      :review-id="reviewId"
      :order-id="orderId"
      :offer-unit="offerUnit"
      :reviewer="reviewer"
      :review-way="reviewWay"
      :bidder="currentBidder"
      :offer-require-tax="offerRequireTax"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import OnlineReviewWayItemDialog from '@/components/online-review/review/OnlineReviewWayItemDialog.vue'

import {
  inquiryReviewTypeDict,
  onlineReviewMethodDict,
  onlineReviewScoreStatusDict
} from '@/dictionary/project/online-review'
import {
  getPurchaseReviewItemSupplierScoreApi,
  reStartPurchaseReviewWayApi,
  submitPurchaseReviewSummaryApi
} from '@/api/procure/purchase-review'
import { arrToObj } from '@/utils/utils'
import { currencyTypeDict } from '@/dictionary/project/common'
import RowEllipsis from '@/components/online-review/RowEllipsis.vue'

/**
 * 评审办法汇总（表头是评审点）
 */
export default {
  name: 'OnlineReviewWaySummary',

  components: { RowEllipsis, Pagination, OnlineReviewWayItemDialog },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    reviewWay: {
      type: Object,
      default: () => {}
    },

    // 是否是在评审任务中显示，目前初步评审也要显示该组件，所以添加标识
    inTask: {
      type: Boolean,
      default: false
    },

    reviewer: {
      type: Object,
      default: () => {}
    },

    reviewClosed: {
      type: Boolean,
      default: false
    },

    offerUnit: {
      type: String,
      default: currencyTypeDict.YUAN.label
    },

    offerRequireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 表格数据
      tableData: [],
      page: 1,
      size: 10,
      total: 0,

      // 列表筛选表单
      filterForm: {
        // 报价单位名称
        supplierName: ''
      },

      // 当前操作中的投标单位
      currentBidder: {}
    }
  },

  computed: {
    // 表头
    tableHead() {
      if (this.isScoreMethod) {
        const defaultList = [{ label: '总分' }]
        if (this.inTask) {
          return defaultList
        }
        return [
          ...defaultList,
          ...(this.reviewWay?.itemInfoList || []).map(item => {
            return { label: item.itemName, id: item.wayItemId }
          })
        ]
      }

      const defaultList = [{ label: '是否通过' }]
      if (this.inTask) {
        return defaultList
      }
      return [
        ...defaultList,
        ...(this.reviewWay?.itemInfoList || []).map(item => {
          return { label: item.itemName, id: item.wayItemId }
        })
      ]
    },

    // 当前评审办法是打分型评审
    isScoreMethod() {
      return this.reviewWay?.reviewMethod === onlineReviewMethodDict.SCORE.value
    },

    // 评审办法已汇总
    reviewCompleted() {
      return (
        this.reviewWay.summaryStatus ===
        onlineReviewScoreStatusDict.COMPLETED.value
      )
    },

    // 是否显示底部操作区
    showFoot() {
      // 评审办法已汇总不显示
      return !this.reviewCompleted && !this.inTask
    },

    // 提交汇总按钮禁用
    submitDisabled() {
      return !this.tableData.length
    },

    // 是否显示评审办法汇总
    showReStart() {
      // 已汇总后显示
      return this.reviewCompleted && !this.inTask && !this.reviewClosed
    },

    wayLabel() {
      return inquiryReviewTypeDict.translate(this.reviewWay.wayType)?.label
    },

    // 是否显示查看评分明细操作
    showWayItemAction() {
      // 当前仅综合评审添加
      if (this.reviewWay.wayType === inquiryReviewTypeDict.BUSINESS.value) {
        return true
      }
      return false
    },

    isPassWay() {
      return this.reviewWay.reviewMethod === onlineReviewMethodDict.PASS.value
    }
  },

  created() {
    this.getTableData()
  },

  methods: {
    /**
     * 获取单元格内容
     */
    getTdContent(head, row) {
      // 如果有评审点id，则返回当前供应商在当前评审点的打分结果
      if (head.id) {
        if (this.isScoreMethod) {
          return { content: row.wayItemScore[head.id].score || '-' }
        }
        return Number(row.wayItemScore[head.id].score)
          ? { content: '通过' }
          : { content: '不通过', className: 'text-danger' }
      }
      if (head.label === '是否通过') {
        return { content: Number(row.score) ? '全通过' : '不通过' }
      }
      if (head.label === '综合评分') {
        return { content: row.score || '-' }
      }

      return { content: '-' }
    },

    /**
     * 获取当前评审办法的评审明细
     */
    getTableData() {
      const params = {
        wayId: this.reviewWay.wayId,
        page: this.page,
        size: this.size,
        ...this.filterForm
      }
      if (this.reviewer?.reviewerId) {
        params.reviewerId = this.reviewer.reviewerId
      }
      getPurchaseReviewItemSupplierScoreApi(this.reviewId, params)
        .then(res => {
          this.total = res.data.total || 0
          this.tableData = (res.data.records || []).map(item => {
            const _itemScores = JSON.parse(item.itemScores) || []
            return {
              ...item,
              wayItemScore: arrToObj(_itemScores, 'wayItemId')
            }
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    handleSearch(value) {
      this.filterForm.supplierName = value
      this.getTableData()
    },

    /**
     * 提交汇总
     */
    submitReviewSummary() {
      this.$systemConfirm('确定提交汇总吗？').then(bool => {
        if (!bool) return
        submitPurchaseReviewSummaryApi(this.reviewId, {
          wayId: this.reviewWay.wayId
        })
          .then(res => {
            this.$emit('afterSummary')
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    /**
     * 重新评审
     */
    reStartReview() {
      this.$systemConfirm(`确定重新评审${this.wayLabel}吗？`).then(result => {
        if (!result) return
        reStartPurchaseReviewWayApi(this.reviewId, {
          wayId: this.reviewWay.wayId
        })
          .then(res => {
            this.$emit('afterReStart')
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    openWayItemDialog(row) {
      this.$refs.onlineReviewWayItemDialog.visible = true
      this.currentBidder = row
    },

    getRowScore(row, item) {
      const rowItem = row.wayItemScore[item.wayItemId]
      if (this.isPassWay) {
        return rowItem.score ? '通过' : '不通过'
      }
      return rowItem.score
    },

    getRowRemark(row, item) {
      const rowItem = row.wayItemScore[item.wayItemId]
      return rowItem?.remark || '-'
    }
  }
}
</script>

<style scoped lang="scss">
.review-summary {
  overflow: hidden;
}

.summary-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $white-color;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid $info-fifth-color;
  height: 56px;
  text-align: center;
  padding: 12px 0;
}

.review-point {
  text-align: left;

  .point-item {
    padding: 8px 0;

    &:not(:last-child) {
      border-bottom: 1px solid $info-fourth-color;
    }

    .item-label {
      color: $text-color;
      &::after {
        content: '：';
      }
    }
  }
}
</style>
